import { useMutation } from '@apollo/client'
import { EditSublocation, EditSublocationVariables } from '../../types'
import { EDIT_SUBLOCATION } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useEditSublocation = ({ onCompleted }: Props) =>
  useMutation<EditSublocation, EditSublocationVariables>(EDIT_SUBLOCATION, { onCompleted })
